import React, { useMemo, useState } from "react";
import { Button, SxProps, Tooltip } from "@mui/material"
import { getAllowedValuesHelper } from "utils";
import { AllowedValuesDTO } from "api";
import { CollectorModal } from "components";
import { SiteSelector } from "../site-selector";

export const AddCollectorButton = ({
  buttonsStyle,
  allowedValues,
  currentBillData,
  setNewSite,
  setNewCollectorId,
}: {
  buttonsStyle: SxProps;
  allowedValues: AllowedValuesDTO;
  currentBillData: any;
  setNewSite: React.Dispatch<React.SetStateAction<{ id: number | undefined, name: string }>>;
  setNewCollectorId: React.Dispatch<React.SetStateAction<number | undefined>>;
}) => {
  const [currentSiteSelected, setCurrentSiteSelected] = useState<
    { siteId: number, siteName: string } | null
  >(allowedValues?.sites?.find((site) => site.siteId === currentBillData?.siteId) ?? null);
  const [addCollectorModalOpen, setAddCollectorModalOpen] = useState<boolean>(false);
  const [addSiteModalOpen, setAddSiteModalOpen] = useState<boolean>(false);

  const currentCollectorData = useMemo(() => currentBillData, [currentBillData]);

  const handleOnClose = (type: "collector" | "site") => {
    setCurrentSiteSelected(allowedValues?.sites?.find((site) => site.siteId === currentCollectorData?.siteId) ?? null);
    if (type === "collector") {
      setAddCollectorModalOpen(false);
    } else {
      setAddSiteModalOpen(false);
    }
  };

  return (
    <>
      <Tooltip title="Create Utility Provider" placement="top">
        <Button
          sx={{
            ...buttonsStyle,
            fontSize: "12px",
            width: "20px",
            minWidth: "20px",
          }}
          variant="contained"
          color="primary"
          onClick={() => setAddSiteModalOpen(true)}
        >
          +
        </Button>
      </Tooltip >
      {addSiteModalOpen && <SiteSelector
        isOpen={addSiteModalOpen}
        onClose={() => handleOnClose("site")}
        sitesList={allowedValues?.sites ?? []}
        currentSiteSelected={currentSiteSelected}
        setCurrentSiteSelected={setCurrentSiteSelected}
        handleNextClick={() => {
          setAddCollectorModalOpen(true);
          setAddSiteModalOpen(false);
        }}
      />}
      {addCollectorModalOpen && <CollectorModal
        isOpen={addCollectorModalOpen}
        onClose={() => handleOnClose("collector")}
        currentSiteSelected={currentSiteSelected}
        allowedValues={getAllowedValuesHelper(allowedValues)}
        currentBillData={currentBillData}
        setNewSite={setNewSite}
        setNewCollectorId={setNewCollectorId}
        dialogPaperSx={{
          borderRadius: '16px',
        }}
        stepHeader={{
          currentStep: 2,
          totalSteps: 2,
        }}
      />}
    </>
  )
}

